import { Component, OnInit } from "@angular/core";

//import { SpecialityService } from 'src/app/_services/speciality.service';

import { SpecialityService } from "./../../_services/speciality.service";

import { FormsModule } from "@angular/forms";
import { INgxMyDpOptions, IMyDateModel } from "ngx-mydatepicker";
import { OrganisationsService } from 'app/_services/organisations.service';
import { MatSnackBar } from "@angular/material";
@Component({
  selector: "app-specialitymaster",
  templateUrl: "./specialitymaster.component.html",
  styleUrls: ["./specialitymaster.component.css"]
})
export class SpecialitymasterComponent implements OnInit {
  speciality: any;
  totalRecords:any = 0;
  page = 0;
  specialityfilter: any = {
    specialityname: "",
    specialitystatus: "Active",
    specialitytype: "",
  };
  
  productLoading:Boolean=false



  size = 10;
  organizationType:any
  constructor(private specialityservice: SpecialityService,
    private orgservice: OrganisationsService,
    private snackBar :MatSnackBar
  ) {}

  ngOnInit() {
    this.getspecialitylist(1, this.specialityfilter);
    this.getOrganizationType()
  }

  getspecialitylist(page: number, specialityfilter) {
    this.specialityservice.getspecialitylist(page - 1, this.size, specialityfilter).subscribe((response) => {
      this.productLoading=true
      if(response.status_code == 200){
        this.speciality = response.Data;
        this.totalRecords = response.total_count;
        this.page = page;
        this.productLoading=false
/*
        this.snackBar.open(response.Metadata.Message, 'close', {
          duration: 2000,
          verticalPosition:"top",
          extraClasses: ['bg-green']
        });
*/
 }else{

        this.speciality = [];
        this.totalRecords = 0 ;
        this.productLoading=false
        this.snackBar.open(response.Metadata.Message, '', {
          duration: 2000,
              verticalPosition:"top",
          extraClasses: ['bg-red']
        });



      }
    },(err: any) => console.log("error", err),() =>
      console.log("getCustomersPage() retrieved customers for page:", +page)
    );
  }

  onSubmit() {

    this.getspecialitylist(1, this.specialityfilter);

  }

  clearfilter() {
    this.specialityfilter.specialityname = "";
    this.specialityfilter.specialitystatus = "";
    this.specialityfilter.specialitytype= "",
    this.getspecialitylist(1, this.specialityfilter);
  }

  pageChanged(event) {
    this.getspecialitylist(event, this.specialityfilter);
  }

  statuschange(specialityid, status) {
    this.specialityservice
      .updatestatus(specialityid, status)
      .subscribe(data => {
        console.log("data", data);
        if (data.status_code == 200) {
          console.log("data", data);
        } else {
          console.log("data", data);
        }
      });
  }

  getOrganizationType(){
    this.orgservice.getOrganizationType().subscribe((response)=>{
  
  console.log("response.Data",response.Data)
  
        this.organizationType = response.Data
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/component/specialitymaster/specialitymaster.component.ts